import {GridCell, gridConstants, GridContainer} from "../../Components/Grid";
import React from "react";

export const PackingListFooterView= () => {

    return <>
        <div className={`footer`}>

            <p><b>If the contents are damaged or missing, please contact the Center immediately.</b></p>

            <p>Packed by: __________________</p>
            <p>Date: ______________________</p>

            <p className={`text-center`}>
                <b>Florida Instructional Materials Center for the Visually Impaired</b>
            </p>
            <GridContainer className={`text-center`}>
                <GridCell small_columns={gridConstants.column.FOUR}>Phone: 813-837-7826</GridCell>
                <GridCell small_columns={gridConstants.column.FOUR}>https://www.fimcvi.org</GridCell>
                <GridCell small_columns={gridConstants.column.FOUR}>Fax: 813-559-8314</GridCell>
            </GridContainer>
        </div>
    </>;
};
